// Bootstrap
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Collapse from 'bootstrap/js/dist/collapse';
import Carousel from 'bootstrap/js/dist/carousel';
import Toast from 'bootstrap/js/dist/toast';

// Flawless
import QuantitySelector from './custom/quantity-selector';
import DropDown from './custom/dropdown';
import CategoriesDisplay from './home/categories-display';
import Bar from './marketing/cartinfobar/bar';
import Media from './catalog/product/view/media';

(function () {
  QuantitySelector.initialize();
  DropDown.initialize();
  CategoriesDisplay.initialize();
  Bar.initialize();
  Media.initialize();
})();